var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighvalue3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 5H29.55C28.5 2.1 25.75 0 22.5 0C19.25 0 16.5 2.1 15.45 5H5C2.25 5 0 7.25 0 10V45C0 47.75 2.25 50 5 50H40C42.75 50 45 47.75 45 45V10C45 7.25 42.75 5 40 5ZM22.5 5C23.875 5 25 6.125 25 7.5C25 8.875 23.875 10 22.5 10C21.125 10 20 8.875 20 7.5C20 6.125 21.125 5 22.5 5ZM17.5 40L7.5 30L11.025 26.475L17.5 32.925L33.975 16.45L37.5 20L17.5 40Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighvalue3);
export default __webpack_public_path__ + "static/media/highvalue3.1ce4e70d8a394e91fae12590c93a1f83.svg";
export { ForwardRef as ReactComponent };